import React from 'react';

import styles from './GameQuestionsSection.scss';
import GameQuestions from 'Components/GameQuestions';

const GameQuestionsSection = ({ slug }) => {
  return (
    <div className={`GameQuestionsSection GameQuestionsSection--${slug}`}>
      <div className="GameQuestionsSection__container">
        <GameQuestions theme="section" slug={slug} />
      </div>
    </div>
  );
};

export default GameQuestionsSection;
